import React, {useEffect, useState} from 'react';
import axios from "axios";
export const RatesContext = React.createContext({})
function RatesProvider(props) {
    const [rates,setRates] = useState(false)
    const  ltv = (loan,value)=>{
        // to 1 dec place
        return Math.round((loan / value) * 100 * 10) / 10
    }

    useEffect(()=>{
        if (!rates){
            console.log('fetching latest rates')
            const endpoint = 'https://itdhvdcdl4ozbvsic34gs6kxzu0okfdm.lambda-url.eu-west-1.on.aws/'
            axios.get(endpoint).then(response => {
                setRates(response.data)
            })
        }
    },[])
    const approvedRates = (propertyValue,loanRequired,loanTerm) => {
        if (!rates){
            return []
        }
        const myLTV = ltv(loanRequired, propertyValue)
        let lastError = false
        const r = rates.filter(item => {
            if (myLTV > item.ltv) {
                lastError = 'Try decreasing the loan amount'
                return false
            }
            if (item?.minLoan && item.minLoan > loanRequired) {
                lastError = 'Try increasing the loan amount'
                return false
            }
            if (item?.maxLoan && item.maxLoan < loanRequired) {
                lastError = 'Try reducing the loan amount'
                return false
            }
            if (item?.minTerm && item.minTerm > loanTerm) {
                lastError = 'Try increasing the loan term'
                return false
            }
            if (item?.maxTerm && item.maxTerm < loanTerm) {
                lastError = 'Try decreasing the loan term'
                return false
            }
            return true
        })
        return r.length > 0 ? r : {error: lastError}
    }
    return (
        <RatesContext.Provider value={{
            rates: rates,
            getApprovedRates: approvedRates
        }}>
            {props.children}
        </RatesContext.Provider>
    );
}

export default RatesProvider;